import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WidgetBoxedLayoutComponent } from './custom-layout/widget-boxed-layout/widget-boxed-layout.component';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { CanActivateTeam } from 'src/services/canActivateRoute.service';
import { CanActivateAdmin } from 'src/services/canActivateAdmin.service';


const routes: VexRoutes = [
  
  {
    path: 'widget',
    loadChildren: () => import('./pages/widget/widget.module').then(m => m.WidgetModule),
  },
  {
    path: 'widget-boxed',
    component: WidgetBoxedLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./custom-layout/widget-boxed-layout/widget-boxed-layout.module').then(m => m.WidgetBoxedLayoutModule),
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
    })
    
  ],
  exports: [RouterModule, QuicklinkModule],
  providers: [CanActivateTeam, CanActivateAdmin]
})
export class AppRoutingModule {
}
